import type { StepType } from "@reactour/tour";
import { ONBOARDED, ONBOARDING, REGISTERED } from "codes";

export const DASHBOARD_STEPS: Record<string, StepType[]> = {
  [REGISTERED]: [
    {
      selector: "#account-overview",
      content: "This provides an overview of your KPIs",
    },

    // {
    //   selector: "#track-your-cargo",
    //   content: "If you would like to Track your Cargo, click here",
    // },
    {
      selector: "#check-country-eligibility",
      content:
        "Click here if you would like to check on the Supplier/Buyer Country Eligibility",
    },
    {
      selector: "#faq",
      content: "Click here for FAQ",
    },
    {
      selector: "#company-logo",
      content: "Go back to your dashboard anytime clicking here!",
    },
    {
      selector: "#profile",
      content: "View/Adjust your profile or logout here.",
    },
    {
      selector: "#notifications",
      content: "Click here to find out your notifications",
    },
    {
      selector: "#language-switcher",
      content: "Choose your preferred language!",
    },
  ],
  [ONBOARDING]: [
    {
      selector: "#account-overview",
      content: "This provides an overview of your KPIs",
    },

    // {
    //   selector: "#track-your-cargo",
    //   content: "If you would like to Track your Cargo, click here",
    // },
    {
      selector: "#check-country-eligibility",
      content:
        "Click here if you would like to check on the Supplier/Buyer Country Eligibility",
    },
    {
      selector: "#faq",
      content: "Click here for FAQ",
    },
    {
      selector: "#company-logo",
      content: "Go back to your dashboard anytime clicking here!",
    },
    {
      selector: "#profile",
      content: "View/Adjust your profile or logout here.",
    },
    {
      selector: "#notifications",
      content: "Click here to find out your notifications",
    },
    {
      selector: "#language-switcher",
      content: "Choose your preferred language!",
    },
  ],
  [ONBOARDED]: [
    {
      selector: "#account-overview",
      content: "This provides an overview of your KPIs",
    },
    {
      selector: "#todo",
      content: "Overview of statuses and things to-do",
    },

    // {
    //   selector: "#track-your-cargo",
    //   content: "If you would like to Track your Cargo, click here",
    // },
    {
      selector: "#check-country-eligibility",
      content:
        "Click here if you would like to check on the Supplier/Buyer Country Eligibility",
    },
    {
      selector: "#faq",
      content: "Click here for FAQ",
    },
    {
      selector: "#company-logo",
      content: "Go back to your dashboard anytime clicking here!",
    },
    {
      selector: "#profile",
      content: "View/Adjust your profile or logout here.",
    },
    {
      selector: "#notifications",
      content: "Click here to find out your notifications",
    },
    {
      selector: "#company-logo",
      content: "Go back to your dashboard anytime clicking here!",
    },
    {
      selector: "#language-switcher",
      content: "Choose your preferred language!",
    },
  ],
};
